import { render, staticRenderFns } from "./myTrainee.vue?vue&type=template&id=98529fb8&scoped=true&"
import script from "./myTrainee.vue?vue&type=script&lang=js&"
export * from "./myTrainee.vue?vue&type=script&lang=js&"
import style0 from "./myTrainee.vue?vue&type=style&index=0&id=98529fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98529fb8",
  null
  
)

export default component.exports